module.exports = __webpack_public_path__ + "img/img-parts-sishu02.409e2efb.png";